import React from 'react'
import PropTypes from 'prop-types'

const dropSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
            <g>
                <path d=" M 18 13.181 C 16.65 10.313 13.275 6.938 11.926 0.864 C 10.576 6.938 7.032 10.144 6.02 13.181 C 5.176 15.375 5.008 17.568 6.189 19.762 C 7.37 21.955 9.563 23.136 11.926 23.136 C 14.288 23.136 16.481 21.955 17.662 19.762 C 19.012 17.568 18.843 15.375 18 13.181 Z  M 11.926 21.786 L 11.926 21.786 C 10.407 21.786 9.226 21.28 8.214 20.099 C 8.72 20.436 9.226 20.605 9.732 20.774 C 12.432 21.28 15.131 19.424 15.806 16.556 C 15.806 16.387 15.806 16.218 15.806 16.05 C 15.806 15.881 15.806 15.881 15.806 15.712 C 15.806 15.543 15.806 15.543 15.806 15.375 C 15.975 15.037 15.975 14.7 15.975 14.362 C 15.806 14.025 17.325 14.193 17.156 16.724 C 16.987 19.593 14.794 21.786 11.926 21.786 Z "
                      fill={color}/>
            </g>
    </svg>
)

dropSVG.defaultProps = {
    color: '#28AAE1',
    width: 24,
    height: 24,
}

dropSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (dropSVG)
